import { Link } from "@tanstack/react-router"
import { Github, Twitter, Linkedin, Mail } from "lucide-react"

const socialLinks = [
  { icon: Github, href: "https://github.com/matricks-ai", label: "GitHub" },
  { icon: Twitter, href: "https://twitter.com/matricks_ai", label: "Twitter" },
  { icon: Linkedin, href: "https://linkedin.com/company/matricks-ai", label: "LinkedIn" },
  { icon: Mail, href: "mailto:hello@matricks.ai", label: "Email" },
]

const legalLinks = [
  { label: "Privacy Policy", href: "/legal/privacy" },
  { label: "Terms of Service", href: "/legal/terms" },
  { label: "Security", href: "/legal/security" },
  { label: "Compliance", href: "/legal/compliance" },
]

export function FooterMinimal() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="border-t bg-muted/30">
      <div className="container px-6 py-12">
        <div className="flex flex-col items-center text-center">
          {/* Logo and Tagline */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary">
              <span className="text-sm font-bold text-primary-foreground">M</span>
            </div>
            <span className="text-xl font-bold">Matricks.ai</span>
          </Link>
          <p className="mt-3 text-sm text-muted-foreground max-w-md">
            Secured Enterprise Integration & Agentic AI Platform
          </p>

          {/* Social Links */}
          <div className="mt-6 flex items-center gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-lg p-2 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
                aria-label={social.label}
              >
                <social.icon className="h-5 w-5" />
              </a>
            ))}
          </div>

          {/* Legal Links */}
          <div className="mt-8 flex flex-wrap justify-center gap-4 text-sm">
            {legalLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Copyright */}
          <div className="mt-8 pt-6 border-t w-full">
            <p className="text-xs text-muted-foreground text-center">
              &copy; {currentYear} Matricks.ai. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
